import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { DASHBOARD_DEVICES, DASHBOARD_DEVICES_SUCCESS, DASHBOARD_DEVICES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getDashboardDevices({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/devices`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: DASHBOARD_DEVICES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DASHBOARD_DEVICES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DASHBOARD_DEVICES_ERROR, payload: error });
  }
}

export function* watchDashboardDevices() {
  yield takeEvery(DASHBOARD_DEVICES, getDashboardDevices);
}

function* watchDashboardDevicesSaga() {
  yield all([fork(watchDashboardDevices)]);
}

export default watchDashboardDevicesSaga;
